var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pat3"},[_c('div',{staticClass:"main"},[_c('b',[_vm._v("Participate process")]),_c('h1',[_vm._v("参与流程")]),_c('el-image',{attrs:{"src":_vm.participatePath,"fit":"cover"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }